export default "__VITE_ASSET__C5614R_M__"